import { STORAGE_CALC_PROGRESS_KEY } from './constants';
import { CalcProgress, DEFAULT_PROGRESS } from './Progress.types';

export const getCalcProgressFromSessionStorage = (): CalcProgress => {
    const storedCalcProgress: string | null = sessionStorage.getItem(
        STORAGE_CALC_PROGRESS_KEY
    );
    if (!storedCalcProgress) {
        return DEFAULT_PROGRESS;
    }
    const parsedStoredCalcProgress: CalcProgress =
        JSON.parse(storedCalcProgress);
    return parsedStoredCalcProgress;
};

export const setCalcProgressToSessionStorage = (
    currentCalcProgress: CalcProgress
) => {
    sessionStorage.setItem(
        STORAGE_CALC_PROGRESS_KEY,
        JSON.stringify(currentCalcProgress)
    );
};

export const removeCalcProgressFromSessionStorage = () => {
    sessionStorage.removeItem(STORAGE_CALC_PROGRESS_KEY);
};
